import React from 'react'

import store from './store'

import { Provider } from 'react-redux'
import { Router, Route, IndexRoute } from 'react-router'
import { createHashHistory } from 'history'
import { syncHistoryWithStore } from 'react-router-redux'

import AppV2 from 'containers/AppV2'
import ProfileV2 from 'containers/ProfileV2'
import ResultsV2 from 'containers/ResultsV2'
import FeedbackStandalone from 'containers/FeedbackStandalone'
import RatingStandalone from 'containers/RatingStandalone'

const basedBrowserHistory = createHashHistory({})
export const history = syncHistoryWithStore(basedBrowserHistory, store)

export const SimpleRoutesV2 = () => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Route path='/' component={AppV2}>
          <IndexRoute component={ProfileV2} />
          <Route path='/resultados' component={ResultsV2} />
        </Route>
      </Router>
    </Provider>
  )
}

// Inquérito de satisfação isolado (sem AppV2/simulador à volta), para poder ser
// servido sozinho e embebido num iframe. Só precisa do store para a submissão.
export const FeedbackRoutes = () => {
  return (
    <Provider store={store}>
      <FeedbackStandalone />
    </Provider>
  )
}

// Avaliação da adesão (rating) isolada, servida sozinha e embebida num iframe
// do site pai. É autónoma (não depende do store/AppV2), mas mantemos o Provider
// por paridade com os restantes módulos.
export const RatingRoutes = () => {
  return (
    <Provider store={store}>
      <RatingStandalone />
    </Provider>
  )
}



// WEBPACK FOOTER //
// ./src/routesV2.js